import { ReactElement, useState } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage, useMessageGetter } from '@messageformat/react';
import { Row, Col, Alert } from '@op/opds.opux';
import CourseTaskHeader from '../CourseTaskHeader';
import SegmentedButtonQuestionTile from '../SegmentedButtonQuestionTile';
import { getMsgValues } from '../../utils';

const COURSE_NUMBER = 8;
const TASK_NUMBER = 2;

const TaskTwo = (): ReactElement => {
  const getTaskText = useMessageGetter('course8.task2');
  const options1 = getMsgValues(useMessage('course8.task2.question1.options'));
  const options2 = getMsgValues(useMessage('course8.task2.question2.options'));
  const options3 = getMsgValues(useMessage('course8.task2.question3.options'));
  const options4 = getMsgValues(useMessage('course8.task2.question4.options'));
  const options5 = getMsgValues(useMessage('course8.task2.question5.options'));
  const options6 = getMsgValues(useMessage('course8.task2.question6.options'));

  const [correctAnswers, setCorrectAnswers] = useState(Array(6).fill(false));

  const updateAnswers = (value: 1 | 2 | 3 | 4 | 5 | 6) => {
    return (isCorrect: boolean): void => {
      const newAnswers = [...correctAnswers];
      newAnswers[value - 1] = isCorrect;
      setCorrectAnswers(newAnswers);
    };
  };

  return (
    <div style={{ marginBottom: space.default }}>
      <CourseTaskHeader questionNumber={2} totalQuestions={2} headingAs="h2" />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl }}
      >
        <Message id="course8.task2.title" />
      </h3>
      <div
        className="opds-styles-v1-text-body-medium"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.default,
        }}
      >
        <Message id="course8.task2.body" />
      </div>
      <Row style={{ marginTop: space.default, marginLeft: 0, marginRight: 0 }}>
        <Col
          style={{ display: 'flex', flexDirection: 'column' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-left-small-padding"
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="1"
            correctAnswer={options1[1]}
            options={options1}
            onAnswered={updateAnswers(1)}
            infoText={getTaskText('question1.info')}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="2"
            correctAnswer={options2[1]}
            options={options2}
            onAnswered={updateAnswers(2)}
            infoText={getTaskText('question2.info')}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="3"
            correctAnswer={options3[1]}
            options={options3}
            onAnswered={updateAnswers(3)}
            infoText={getTaskText('question3.info')}
          />
        </Col>
        <Col
          style={{ display: 'flex', flexDirection: 'column' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-right-small-padding"
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="4"
            correctAnswer={options4[1]}
            options={options4}
            onAnswered={updateAnswers(4)}
            infoText={getTaskText('question4.info')}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="5"
            correctAnswer={options5[0]}
            options={options5}
            onAnswered={updateAnswers(5)}
            infoText={getTaskText('question5.info')}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="6"
            correctAnswer={options6[0]}
            options={options6}
            onAnswered={updateAnswers(6)}
            infoText={getTaskText('question6.info')}
          />
        </Col>
      </Row>
      {correctAnswers.filter(Boolean).length === 6 && (
        <Alert type="positive">
          <Message id="answers_correct" />
        </Alert>
      )}
    </div>
  );
};

export default TaskTwo;
